module.exports = __webpack_public_path__ + "static/media/RXCG Audit.8bc4175c.pdf";